/**
 * Deep P, the finale: the exit is locked behind a ruby door. The ruby key lies in a steel vault
 * inside a firefly moat, behind a gold and a jade door. Around them: a slime still over a magic
 * wall, an amoeba pit with a creeper rim, butterflies under slime taps and four clocks
 * (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepP: CaveDef = {
  id: 'P',
  name: 'THE ROOT',
  hint: 'Gold, jade, ruby: the last key opens the way out.',
  intermission: false,
  colors: [9, 12, 1],
  diamondValue: 30,
  extraValue: 60,
  amoebaTime: 30,
  magicWallTime: 15,
  fill: { base: '.', items: [['r', 12], ['d', 5]] },
  levels: [
    { seed: 6601, diamonds: 30, time: 200 },
    { seed: 6602, diamonds: 36, time: 185 },
    { seed: 6603, diamonds: 42, time: 170 },
    { seed: 6604, diamonds: 48, time: 155 },
    { seed: 6605, diamonds: 54, time: 140 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W??wwwww??????????.P.?????????........?W',
    'W??wrrrw????????t?...????????wx.......wW',
    'W??wrdrw??????????...????????w........wW',
    'W??wrrrw???????????????.1.???w........wW',
    'W??wsssw?????????????????????w........wW',
    'W?.......?????????????t??????w........wW',
    'W?wwmmmww?????.?????????????.d...a....wW',
    'W?w     w????w.wwwwwwwwwwww??WwwwwwwwwwW',
    'W?w     ..???x.d..d.d..d.d2w???????????W',
    'W?wwwwwww????wwwwwwwwwwwww.????????????W',
    'WWWWWWWWWWWWW????????????.....r....r...W',
    'WW    f     W??????????????............W',
    'WW WWWWWWWW W????????????????wsw??wsw??W',
    'WW Wddddd35 4.???????????????w w??w w??W',
    'WW WWWWWWWW W????????????????wbw??wbw??W',
    'WW     F    W????????????????www??www??W',
    'WWWWWWWWWWWWW??????????????????????????W',
    'W??????????????t?WWWWWW????????????????W',
    'W????????????????W....6.?t?????????????W',
    'W????????????????W.X..W????????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
